"use strict";

var _marked = /*#__PURE__*/regeneratorRuntime.mark(generator);

Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
/**
 * Triangle
 *
 * The triangle number sequence - 1, 3, 6, 10, 15, 21
 *   = 1, (1 + 2), (1 + 2 + 3) etc
 */
// Public API
exports.default = function () {
  return (0, immutable_1.Seq)(generator(1));
};
// Generator
// The general formula for the nth triangle number is n*(n + 1)/2
// If the current number is x, then x = n*(n + 1)/2
// and so with a bit of algebra and the quadratic formula (only taking the positive answer)
// n = (1 + 8*x)^(1/2)/2
// So we can work out from the current value that it's the nth value, and then just
// add n + 1 to get the next term
// e.g. if current term is 10, then the above formula tells us it's the 4th term,
// so we add 5 to get the 5th term = 15
function generator(current) {
  var n;
  return regeneratorRuntime.wrap(function generator$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return current;

        case 2:
          n = (Math.sqrt(1 + 8 * current) - 1) / 2;
          return _context.delegateYield(generator(current + n + 1), "t0", 4);

        case 4:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}
//# sourceMappingURL=triangle.js.map


//////////////////
// WEBPACK FOOTER
// ./client/vendor/number-sequences/dist/triangle.js
// module id = 281
// module chunks = 0